import Link from "next/link";
import React from "react";

const SinglesGame = (props) => (
  <div className="singles-game-wrapper">
    <style jsx>{`
      .singles-game {
        cursor: pointer;
        padding: 10px;
        transition: background-color 0.2s ease;
        border-radius: 10px;
        margin: 10px;
      }

      .singles-game:hover {
        background-color: ${props.game == 6 || props.game === 21
          ? "#FFCB05"
          : props.game === 1 || props.game === 18
          ? "#0097B2"
          : " #ff0000"};
      }
    `}</style>

    <Link
      href={{ pathname: `/singles`, query: { game: props.game } }}
      as={`/singles?game=${props.game}`}
    >
      <a>
        <div className="singles-game">
          {props.game === 1 ? (
            <img
              src="/img/game-singles/mtg.png"
              alt="Singles Magic the Gathering"
            />
          ) : props.game === 6 ? (
            <img src="/img/game-singles/pkm.png" alt="Cartonase Pokemon" />
          ) : props.game === 3 ? (
            <img src="/img/game-singles/ygo.png" alt="Singles Yu-Gi-Oh! TCG" />
          ) : props.game === 18 ? (
            <img
              src="/img/game-singles/op.png"
              alt="Cartonase One Piece Card Game"
            />
          ) : props.game === 21 ? (
            <img
              src="/img/game-singles/swu.png"
              alt="Singles Star Wars Unlimited"
            />
          ) : null}
        </div>
      </a>
    </Link>
  </div>
);

export default SinglesGame;
